import './AllInstallations.scss';
import { useState } from 'react';
import Button from 'components/Button/Button';
import { useNavigate } from 'react-router-dom';
import { defaultSortOptions } from 'pages/Agent/menuLinks';
import CircularProgress from '@mui/material/CircularProgress';
import { agentInstallationFilters } from 'pages/Agent/navigation';
import useInstallationsSearch, { InstallationSortLabel } from 'functions/hooks/useInstallationsSearch';
import InstallationList from 'components/InstallationList/InstallationList';
import InstallationCard from 'components/InstallationCard/InstallationCard';
import FilterNavigation from 'components/FilterNavigation/FilterNavigation';
import Pagination from 'components/Pagination/Pagination';

export default function AllInstallations() {

  const navigate = useNavigate();
  const [submittedQuery, setSubmittedQuery] = useState('');
  const [sort, setSort] = useState<InstallationSortLabel>('Latest');

  const {
    installations,
    loading,
    error,
    pageIndex,
    hasNext,
    hasPrev,
    next,
    prev,
  } = useInstallationsSearch({ query: submittedQuery, sort, pageSize: 10 });

  return (
    <>
      <FilterNavigation
        filters={agentInstallationFilters}
        sortOptions={defaultSortOptions}
        searchMode='submit'
        searchButtonLabel='Search'
        hideExtraOnMobile
        onSearchSubmit={(text) => setSubmittedQuery(text?.trim() || '')}
        onSortChange={(label) => setSort(label as InstallationSortLabel)}
      />
      <div className="all-installations">

        <div className="filter-navigation">
          <div className="action-buttons">
            <Button
              onClick={() => navigate('/agent/installations/@new')}
              label="Add Installation"
            />
          </div>
        </div>

        <InstallationList>
          {loading && (
            <div className='installation-list__loader'>
              <CircularProgress />
            </div>
          )}
          {!loading && error && (
            <div className='installation-list__error' role='alert'>
              {error}
            </div>
          )}
          {!loading && !error && installations.map((installation) => (
            <InstallationCard
              key={installation.id}
              installation={installation}
              onClick={() => navigate(`/agent/installations/${installation.id}`)}
            />
          ))}
        </InstallationList>
        {!loading && !error && (
          <Pagination
            pageIndex={pageIndex}
            hasPrev={hasPrev}
            hasNext={hasNext}
            onPrev={prev}
            onNext={next}
          />
        )}
      </div>
    </>
  );
}
